import { render, staticRenderFns } from "./AtopicDermatitisFormNode.vue?vue&type=template&id=799b6630&"
import script from "./AtopicDermatitisFormNode.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisFormNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports